import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { documentTitle, moduleLabelForPath } from "@/app/document-title";

export function DocumentTitleSync() {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	useEffect(() => {
		const brand = t("app.brand");
		document.title = documentTitle(brand, moduleLabelForPath(pathname, t));
	}, [pathname, t]);

	return null;
}
